// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Oswald_2c607e', '__Oswald_Fallback_2c607e'","fontStyle":"normal"},"className":"__className_2c607e"};